"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      value: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        }
      }
    };
  },
  methods: {
    handclickdate: function handclickdate(vm) {
      this.$emit("dateObj", vm);
    },
    change: function change(command) {
      if (command != '自定义') {
        this.value = '';
      }
    }
  }
};